export default __webpack_public_path__ + "static/media/solution_71.a32a102a.svg";